export const PREMIUM_SERVICE = {
  guidesSessions: 'guides_sessions',
  chatbot: 'chatbot',
  commerce: 'commerce',
  events: 'events',
  surveys: 'surveys',
  discourseCommunity: 'discourse_community',
  piggybackr: 'piggybackr',
};

export const PREMIUM_SERVICE_DEFAULT_ENABLED = {
  [PREMIUM_SERVICE.guidesSessions]: true,
  [PREMIUM_SERVICE.chatbot]: true,
  [PREMIUM_SERVICE.commerce]: true,
  [PREMIUM_SERVICE.events]: true,
  [PREMIUM_SERVICE.surveys]: false,
  [PREMIUM_SERVICE.piggybackr]: false,
  [PREMIUM_SERVICE.discourseCommunity]: false,
};

export const GUIDE_COST_DISPLAY = {
  dollarOnly: 'dollar_only',
  creditsOnly: 'credits_only',
  hideAll: 'hide_all',
};
